import React, { useEffect, useState, useRef } from 'react';
import ChecklistView from '../../views/AdminView/ChecklistView';
import { 
    getAllChecklists, 
    createChecklist, 
    updateChecklist, 
    deleteChecklist,
    toggleChecklistStatus,
    fetchServiceCategory
} from '../../services/api';

const ChecklistComponent = () => {
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);
    const [checklists, setChecklists] = useState([]);
    const [serviceCategories, setServiceCategories] = useState([]);

    const handleChecklistAddOrUpdate = async ({ id, data }) => {
        setLoading(true);
        try {
            let response;
            if (id !== undefined && id > 0) {
                response = await updateChecklist(id, data);
            } else {
                response = await createChecklist(data);
            }
            await getData();
            setLoading(false);
            return response;
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };

    const handleDeleteChecklist = async (id) => {
        setLoading(true);
        try {
            const response = await deleteChecklist(id);
            await getData();
            setLoading(false);
            return response;
        } catch (error) {
            console.error('Error deleting checklist:', error);
            setLoading(false);
            throw error;
        }
    };

    const handleToggleStatus = async (id) => {
        setLoading(true);
        try {
            const response = await toggleChecklistStatus(id);
            await getData();
            setLoading(false);
            return response;
        } catch (error) {
            console.error('Error toggling checklist status:', error);
            setLoading(false);
            throw error;
        }
    };

    const getData = async () => {
        try {
            const response = await getAllChecklists();
            setChecklists(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching checklists:', error);
            setLoading(false);
        }
    };

    const loadServiceCategories = async () => {
        try {
            const res = await fetchServiceCategory();
            setServiceCategories(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            console.error('Error fetching service categories:', error);
            setServiceCategories([]);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            loadServiceCategories();
            didFetch.current = true;
        }
    }, []);

    return (
        <div>
            {!loading && checklists != null && (
                <ChecklistView 
                    checklists={checklists}
                    serviceCategories={serviceCategories}
                    onAddOrUpdate={handleChecklistAddOrUpdate}
                    onDeleteChecklist={handleDeleteChecklist}
                    onToggleStatus={handleToggleStatus}
                    onRefresh={getData}
                />
            )}
        </div>
    );
};

export default ChecklistComponent;

